jQuery(document).ready(function ($) {
	// On burger menu click + on close button, toggle mobile menu content
	$("#burger-menu, #close-mobile-menu, #mobile-backdrop").on(
		"click",
		function () {
			const $menu = $("#mobile-menu-content");
			const $header = $("#primary-header");
			
			if ($menu.is(":hidden")) {
				$header.attr('data-mobile-active', 'true');
				$menu.css("right", "-100%").show().animate({
					right: "0"
				}, 300);				
			} else {
				$header.attr('data-mobile-active', 'false');
				$menu.animate({
					right: "-100%"
				}, 300, function() {
					$(this).hide();					
				});
			}
		}
	);

	// Mobile submenu toggles
	const mobileMenuItems = document.querySelectorAll("ul.menu-items-mobile a");

	mobileMenuItems.forEach((item) => {
		item.addEventListener("click", function (e) {
			// Find the submenu that corresponds to this link
			const submenu = this.closest("li").querySelector('[class^="mobile-"]');
			if (!submenu) return;

			e.preventDefault(); // Prevent navigation if there's a submenu

			// Find and rotate the SVG icon
			const svg = this.querySelector("svg");
			if (svg) {
				svg.style.transform =
					submenu.style.display === "none" ? "rotate(90deg)" : "rotate(0deg)";
			}

			// Hide all other submenus first
			document.querySelectorAll('[class^="mobile-"]').forEach((menu) => {
				if (menu !== submenu) {
					menu.style.display = "none";
				}
			});

			// Toggle the clicked submenu
			submenu.style.display =
				submenu.style.display === "none" ? "block" : "none";
		});
	});

	// Search
	$("#search-trigger").on("click", function () {
		$("#search-modal").show();
		$("#search-modal").animate({ top: "0" }, 600);
	});

	$("#search-close").on("click", function () {
		$("#search-modal").animate({ top: "100vh" }, 600, function () {
			$(this).css("display", "none");
		});
	});

	// TOC Navigation
	jQuery(document).ready(function ($) {
		$(".toggle-toc").on("click", function () {
			const $nav = $(this).siblings(".toc");
			const $button = $(this);
			const $arrow = $button.find("svg");

			$nav.slideToggle(300, function () {
				if ($nav.is(":visible")) {
					$button.find("span").text("Close contents");
					$arrow.css("transform", "rotate(0deg)");
				} else {
					$button.find("span").text("Jump to section");
					$arrow.css("transform", "rotate(180deg)");
				}
			});
		});
	});
});

jQuery(window).scroll(function () {
	const $ = jQuery;
	const scroll = $(window).scrollTop();
	const header = $("#primary-header");

	if (scroll > 50) {
		header
			.removeClass("bg-transparent")
			.addClass("bg-white")
			.addClass("scroll-active");
	} else {
		header
			.removeClass("bg-white")
			.removeClass("scroll-active")
			.addClass("bg-transparent");
	}
});
